import React from 'react'
import { Box, styled } from '@mui/material'
import RelatedReports from '../relatedReports/RelatedReports'
import { isEmpty } from 'src/utils'

/**
 * Related Reports Container
 * theme path: RelatedReports.styleOverrides.container
 */
const RelatedContainer = styled(Box, {
  name: 'RelatedReports',
  label: 'relatedReportsContainer',
  overridesResolver: (props, styles) => [styles.container]
})(({ theme }) => ({
  margin: '10px 0px 10px',
  padding: '16px',
  backgroundColor: theme.palette?.relatedMessage?.background || '#fcfcfd',
  borderRadius: '30px',
  boxShadow:
    '0 1px 3px 0 rgba(16, 24, 40, 0.1), 0 1px 2px 0 rgba(16, 24, 40, 0.06), 0 1px 3px 0 rgba(16, 24, 40, 0.1), 0 1px 2px 0 rgba(16, 24, 40, 0.06)',
  border: `solid 1px ${theme.palette?.relatedMessage?.border || '#d5d9eb'}`
}))

const RelatedMessage = ({ show, relatedReports }) => {
  if (isEmpty(relatedReports) || !show) return <></>
  return (
    <RelatedContainer data-testid="related-message">
      {!isEmpty(relatedReports) && <RelatedReports articles={relatedReports} />}
    </RelatedContainer>
  )
}

export default RelatedMessage
